// extracted by mini-css-extract-plugin
export default {"container":"container-pG7PM4Ulc96fnvMVNfa2"};